import { Sucursal } from "../../entities/catalogos/Sucursal";
import { LOAD_SUCURSALES_MANY_SUCCESS, SucursalManyActionTypes } from "../types/sucursalActionTypes";


export default function sucursalManyReducer(state = [], action: SucursalManyActionTypes): Sucursal[] {
    switch (action.type) {
        case LOAD_SUCURSALES_MANY_SUCCESS:
            return action.sucursalesMany;
        default:
            return state;
    }
}

